module.exports = __webpack_public_path__ + "media/images/filter-icon-422405c411f6647d96957047e5a17127.png";